import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetOpinionsList,
	GetOpinionsListModel,
	GetOpinionsListParams,
} from 'domain/usecases/private/my-hospitalization/get-opinions-list';

export class RemoteGetOpinionsList implements GetOpinionsList {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetOpinionsListModel>,
	) {}

	async get({signal, ...params}: GetOpinionsListParams): Promise<GetOpinionsListModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
